(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

document.addEventListener('DOMContentLoaded', function (e) {
  var testimonialForm = document.getElementById('church-testimonial-form');
  testimonialForm.addEventListener('submit', function (e) {
    e.preventDefault(); // reset the form messages

    resetMessages(); // collect all the data

    var data = {
      name: testimonialForm.querySelector('[name="name"]').value,
      email: testimonialForm.querySelector('[name="email"]').value,
      message: testimonialForm.querySelector('[name="message"]').value,
      nonce: testimonialForm.querySelector('[name="nonce"]').value // validate everything

    };

    if (!data.name) {
      testimonialForm.querySelector('[data-error="invalidName"]').classList.add('show');
      return;
    }

    if (!validateEmail(data.email)) {
      testimonialForm.querySelector('[data-error="invalidEmail"]').classList.add('show');
      return;
    }

    if (!data.message) {
      testimonialForm.querySelector('[data-error="invalidMessage"]').classList.add('show');
      return;
    } // ajax http post request


    var url = testimonialForm.dataset.url;
    var params = new URLSearchParams(new FormData(testimonialForm));
    testimonialForm.querySelector('.js-form-submission').classList.add('show');
    fetch(url, {
      method: "POST",
      body: params
    }).then(function (res) {
      return res.json();
    }).catch(function (error) {
      resetMessages();
      testimonialForm.querySelector('.js-form-error').classList.add('show');
    }).then(function (response) {
      resetMessages();

      if (response === 0 || response.status === 'error') {
        testimonialForm.querySelector('.js-form-error').classList.add('show');
        return;
      }

      testimonialForm.querySelector('.js-form-success').classList.add('show');
      testimonialForm.reset();
    });
  });
});

function resetMessages() {
  document.querySelectorAll('.field-msg').forEach(function (f) {
    return f.classList.remove('show');
  });
}

function validateEmail(email) {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

},{}]},{},[1]);
